// extracted by mini-css-extract-plugin
module.exports = {"singleLogo":"FlightCardCarriers-module__singleLogo___HPe6-","carrierLogo":"FlightCardCarriers-module__carrierLogo___NBoJj","grid":"FlightCardCarriers-module__grid___2g0if"};